// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"livestream-event-CourseSessions__wrapper--3O2PP"};